"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "defaultContext", {
  enumerable: true,
  get: function get() {
    return _reactAccessibilityIdContext.defaultContext;
  }
});
var _reactAccessibilityIdContext = _interopRequireWildcard(require("@nerdwallet/react-accessibility-id-context"));
// react-accessibility-provider re-exports the version of react-accessibility-id-context from this package.
// This happens so that when an application has `@nerdwallet/react-accessibility-provider`
// installed at the top of its dependency tree, `useId(..)` will always import this single IdContext
// no matter how many duplicate copies of `@nerdwallet/react-accessibility` exist.
//
// SSRProvider uses this particular IdContext to inject the deterministic id-generator into context
var _default = _reactAccessibilityIdContext.default;
exports.default = _default;